import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className="navbar">
            {/* The Hamburger Icon */}
            <div className={`hamburger ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
            </div>

            {/* Added 'active' class based on state */}
            <div className={`nav-links ${isOpen ? 'active' : ''}`}>
                <li><Link to="/" onClick={toggleMenu}>Välkommen</Link></li>
                <div className='nav-line'>|</div>
                <li><Link to="/osa" onClick={toggleMenu}>OSA</Link></li>
                <div className='nav-line'>|</div>
                <li><Link to="/schema" onClick={toggleMenu}>När & Var</Link></li>
                <div className='nav-line'>|</div>
                <li><Link to="/bra-att-veta" onClick={toggleMenu}>Bra Att Veta</Link></li>
                <div className='nav-line'>|</div>
                <li><Link to="/tal" onClick={toggleMenu}>Tal</Link></li>
                <div className='nav-line'>|</div>
                <li><Link to="/gåvor" onClick={toggleMenu}>Gåvor</Link></li>
            </div>
        </nav>
    );
}

export default Navbar;